import Form from "@/shared/form";
import "./index.scss";
import Image from "next/image";

export default function HeroBanner() {



  return (
    <>
      {/* Hero Section  */}
      <section id="home" className="hero-area relative  min-h-[100vh] flex items-center justify-center text-white">
        <div className="hero-bgimg">
          <Image
            className="object-cover"
            src={'/shared/catering-hero.jpg'}
            fill
            priority
            alt={'Banner Image'}
          />

        </div>
        <div className="banner-content-area grid lg:grid-cols-2 gap-20 items-center max-w-6xl ml-0 px-2">
          <div className="hero-content lg:py-10 pt-10 pb-0 rounded-lg mt-20 w-full">
            <div className="flex items-center justify-start">
              <Image
                width={40}
                height={40}
                className="mb-6"
                src="/shared/svg.png"
                alt="icons"
              />
            </div>
            <h1 className="text-green text-4xl font-bold leading-12">
              Looking for a perfect food affair to complement your Special
              Occasion?
            </h1>
            <p className="mt-4 text-[18px] leading-8">
              Whatever the occasion, be it a wedding, birthday, or corporate
              event, we ensure our catering will impress all your guests. We offer
              gourmet meals made from scratch with premium ingredients,
              customisable for dietary needs including gluten-free and allergies,
              with top-notch food service and organisation.
            </p>
            {/* <a
              href="#quote"
              className="mt-6 text-center tracking-[.15em] text-[14px] bg-red-800 hover:bg-red-900 px-6 py-3 text-white rounded-full inline-block"
            >
              START YOUR CATERING ORDER
            </a> */}
          </div>
          <div className=" lg:max-h-[720px] form-area min text-white py-10 text-center text-5xl lg:mt-35 mb-15 px-5">

          <Form></Form>

          </div>
        </div>
      </section>
    </>
  )
}